<template>
  <div class="container news-center">
    <div class="wrap">
      <div class="left">
        <el-button :class="[query.newsCateId === item.id ? 'activeBtn' : '']" v-for="item in newsCateList" :key="item.id" @click="newsCateChange(item)">{{ item.name }}</el-button>
      </div>
      <div class="right">
        <transition-group name="slide-fade">
          <router-link :to="{ path: 'NewsCenterItem', query: { newsId: item.id } }" class="item" v-for="item in newsList" :key="item.id">
            <div class="left-content">
              <img :src="$baseUrl + item.cover" alt="" class="cover" />
            </div>
            <div class="right-content">
              <div class="title">{{ item.title }}</div>
              <div class="time">{{ item.createTime | formatDate('YYYY-MM-DD') }}</div>
            </div>
          </router-link>
        </transition-group>
      </div>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
  </div>
</template>
<script>
import { getNewsCateList, getNewsList } from '@/api/NewsCenter/NewsCenter'
export default {
  name: 'NewsCenter',
  data() {
    return {
      // 查询新闻列表参数
      query: {
        pageSize: 10,
        pageNum: 1,
        newsCateId: '20210423142835ehftazqeqa'
      },
      // 新闻列表
      newsList: [],
      // 新闻分类列表
      newsCateList: [],
      // 新闻总数
      total: 0
    }
  },
  mounted() {
    // 获取新闻列表
    this.getNewsList()
    // 获取新闻分类列表
    this.getNewsCateList()
  },
  methods: {
    // 获取新闻列表
    async getNewsList() {
      const res = await getNewsList(this.query)
      if (res.code !== 200) {
        return this.$message.error(res.message)
      }
      this.newsList = res.data
      this.total = res.total
    },
    // 获取新闻分类列表
    async getNewsCateList() {
      const res = await getNewsCateList()
      if (res.code !== 200) {
        return this.$message.error(res.message)
      }
      this.newsCateList = res.data
    },
    // 切换查询的新闻分类
    newsCateChange(item) {
      if (item.id === this.query.newsCateId) return
      this.query.newsCateId = item.id
      this.query.pageNum = 1
      this.getNewsList()
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      // 获取新闻列表
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.query.pageNum = val
      // 获取新闻列表
      this.getNewsList()
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 1250px;
  margin: 0 auto;
  padding-top: 30px;
  overflow: hidden;
  .left {
    float: left;
    width: 240px;
    .el-button {
      height: 55px;
      width: 180px;
      background: #ffffff;
      border: 1px solid #cccccc;
      font-size: 18px;
      font-weight: 400;
      line-height: 56px;
      color: #222222;
      margin-bottom: 24px;
      transition: 300ms ease all;
      padding: 0;
      margin-bottom: 30px;
      margin-left: 0;
      &:hover,
      &:active {
        background: #00a4df;
        border: 1px solid #00a4df;
        color: white;
      }
    }
    .activeBtn {
      background: #00a4df;
      border: 1px solid #00a4df;
      color: white;
      &:after {
        content: '';
        position: absolute;
        width: 10px;
        height: 11.54px;
        background: url(../../assets/images/product/icon.png);
        background-size: 100% 100%;
        margin-top: 23px;
        margin-left: 37px;
      }
    }
  }
  .right {
    float: right;
    width: 1000px;
    .item {
      display: block;
      padding: 30px 0;
      border-bottom: 1px solid #eee;
      overflow: hidden;
      &:first-child {
        padding-top: 0;
      }
      .left-content {
        float: left;
        width: 180px;
        height: 110px;
        .cover {
          width: 100%;
          height: 100%;
        }
      }
      .right-content {
        float: right;
        width: 800px;
        .title {
          font-size: 18px;
          line-height: 26px;
          color: #222;
        }
        .time {
          font-size: 18px;
          margin-top: 20px;
          color: #999;
        }
      }
    }
  }
}
.el-pagination {
  margin: 30px 0;
  text-align: center;
}
.slide-fade-enter-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-active {
  transition: all 0s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
